<template>
  <div class="interview">
    <div class="cont-left">
      <ul>
        <li>
          <div class="title">姓名</div>
          <span>:</span>
          <span>{{ roleData.cv_info.name }}</span>
        </li>
        <li>
          <div class="title">性别</div>
          <span>:</span>
          <span>{{ roleData.cv_info.sex_name }}</span>
        </li>
        <li>
          <div class="title">学历</div>
          <span>:</span>
          <span>{{ roleData.cv_info.educ_name }}</span>
        </li>
        <li>
          <div class="title">年龄</div>
          <span>:</span>
          <span>{{ roleData.cv_info.age }}</span>
        </li>
        <li>
          <div class="title">工作年限</div>
          <span>:</span>
          <span>{{ roleData.cv_info.years }}</span>
        </li>
        <li>
          <div class="title">所在地</div>
          <span>:</span>
          <span>{{ roleData.cv_info.province }}-{{ roleData.cv_info.city }}</span>
        </li>
        <li>
          <div class="title">联系电话</div>
          <span>:</span>
          <span>{{ roleData.cv_info.tel }}</span>
        </li>
        <li>
          <div class="title">求职意向</div>
          <span>:</span>
          <span>{{ roleData.cv_info.wish.wish_province }}</span>
        </li>
        <li>
          <div class="title">期望薪水</div>
          <span>:</span>
          <span>{{ roleData.cv_info.wish.wish_salary }}</span>
        </li>
        <li v-if="roleData.invited_info.status!==''">
          <div class="title">邀约状态</div>
          <span>:</span>
          <span>{{ roleData.invited_info.status_info }}</span>
        </li>
      </ul>
    </div>
    <el-form ref="suitable" :model="suitable" class="cont-right" :rules="rules">
      <ul>
        <li>
          <div class="title">企业名称</div>
          <span>:</span>
          <span class="text-show">{{
            roleData.invited_info.company_name
          }}</span>
        </li>
        <li>
          <div class="title">面试时间</div>
          <span>:</span>
          <el-form-item prop="interview_time">
            <el-date-picker
              type="datetime"
              class="el-height"
              placeholder="选择面试时间"
              value-format="timestamp"
              v-model="suitable.interview_time"
            ></el-date-picker>
          </el-form-item>

          <span class="red-text">*</span>
        </li>
        <li>
          <div class="title">面试职位</div>
          <span>:</span>
          <span class="text-show">{{
            roleData.invited_info.position_name
          }}</span>
          <span class="red-text">*</span>
        </li>
        <li>
          <div class="title">企业地址</div>
          <span>:</span>
          <span class="text-show">{{
            roleData.invited_info.company_address
          }}</span>
          <span class="red-text">*</span>
        </li>
        <li>
          <div class="title">联系人</div>
          <span>:</span>
          <el-form-item prop="linkman">
            <el-input
              placeholder="输入联系人"
              v-model="suitable.linkman"
              maxlength="6"
              class="el-height"
              @keyup.enter.native="query"
            ></el-input>
          </el-form-item>

          <span class="red-text">*</span>
        </li>
        <li>
          <div class="title">电话</div>
          <span>:</span>
          <el-form-item prop="phone" class="el-height">
            <el-input
              v-model="suitable.phone"
              placeholder="输入电话"
              @keyup.enter.native="query"
            ></el-input>
          </el-form-item>

          <span class="red-text">*</span>
        </li>
        <li>
          <div class="title">备注</div>
          <span>:</span>
          <el-input
            v-model="suitable.intro"
            class="intro"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            placeholder="如需线上面试请填写线上地址"
            maxlength="200"
          >
          </el-input>
        </li>
      </ul>
    </el-form>
    <div class="edit-btn" v-if="is_edit">
      <el-button type="primary" @click="editFun(1)" v-if="roleData.invited_info.status===1||roleData.invited_info.status===2">修改面试信息</el-button>
      <el-button type="danger" @click="editFun">{{roleData.invited_info.status===1||roleData.invited_info.status===2?'取消本场面试':'再次发起面试'}}</el-button>
    </div>
  </div>
</template>

<script>
import { checkPhone, toTimestamp } from "@/assets/js/public";
import $api from "@/api/ResumeModule";
export default {
  data() {
    return {
      suitable: {
        cv_log_id: "",
        phone: "",
        linkman: "",
        interview_time: "",
        intro: ""
      },
      rules: {
        interview_time: {
          type: "date",
          required: true,
          message: "请选择日期",
          trigger: "change"
        },
        linkman: { required: true, message: "请输入联系人", trigger: "blur" },
        phone: { required: true, validator: checkPhone, trigger: "blur" }
      }
    };
  },
  props: {
    is_edit: Boolean,
    interId: Number,
    roleData: Object,
    dialogType: String
  },
  created() {
    let { linkman, phone, intro, interview_time } = this.roleData.invited_info;
    this.suitable.linkman = linkman;
    this.suitable.phone = phone;
    this.suitable.intro = intro;
    this.suitable.interview_time = interview_time
      ? toTimestamp(interview_time) * 1000
      : "";
    this.suitable.cv_log_id = this.$route.query.cv_log_id;
  },
  methods: {
    Submission(el) {
      this.getSuitable(el);
    },
    //编辑
    editFun(invited) {
      this.getSuitable("suitable",invited);
    },
    getSuitable(el,invited) {
      let invited_status = this.roleData.invited_info.status;
      if(invited_status===1||invited_status===2){
        this.suitable['invited_id'] = this.interId;
      }
      this.$refs[el].validate(valid => {
        if (valid) {
          const {
            interview_time,
            cv_log_id,
            intro,
            invited_id,
            linkman,
            phone
          } = this.suitable;
          const params = {
            //
            interview_time: interview_time / 1000,
            cv_log_id,
            intro,
            invited_id,
            is_invited:invited===1?invited:invited_status===1||invited_status===2? 0:1,
            linkman,
            phone
          };
          console.log(params);
          this.$emit("datamaseg", params, this.dialogType, true);
        }
      });
    }
  }
};
</script>

<style scope>
.interview {
  display: flex;
  justify-content: flex-start;
  color: #333333;
  font-size: 14px;
  padding: 44px 0 40px;
}
.interview .cont-left {
  width: 220px;
  padding: 0 48px;

  border-right: 1px solid#F5F6F9;
}
.interview ul li {
  width: 100%;
  display: flex;
  /* line-height: 47px; */
  padding: 10px 0;
  justify-content: flex-start;
}
.interview ul .title {
  width: 73px;
  text-align: justify;
  text-align-last: justify;
  text-justify: inter-ideograph;
  display: block;
  margin-right: 3px;
}
.interview li span:nth-child(2) {
  margin-left: 5px;
  margin-right: 13px;
}
.interview .cont-right {
  flex: 1;
  padding-left: 50px;
}
.interview .cont-right li {
  position: relative;
  padding-left: 10px;
}
.interview .cont-right .red-text {
  color: red;
  position: absolute;
  left: 0;
  top: 0;
}
.interview .intro {
  width: 280px !important;
  height: 126px;
}
.interview .intro textarea {
  width: 280px;
}
.interview .text-show {
  width: 280px;
}
.interview .el-height {
  width: 280px !important;
}
.interview .el-height div {
  width: 280px;
}
.interview .el-height input {
  width: 280px;
  height: 34px;
  line-height: 34px;
}
.interview .edit-btn {
  width: 100%;
  height: 100px;
  position: absolute;
  bottom: 0;
  background: #fff;
  display: flex;
  justify-content: center;
}
.interview .edit-btn button {
  height: 43px;
  margin: 20px 40px 0;
}
.interview .el-date-picker {
  width: 374px;
}
</style>



// WEBPACK FOOTER //
// src/views/resume/components/interview.vue